"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryType = void 0;
var TelemetryType;
(function (TelemetryType) {
    TelemetryType["INCREMENT"] = "INCREMENT";
    TelemetryType["GAUGE"] = "GAUGE";
    TelemetryType["TIMER"] = "TIMER";
    TelemetryType["OUTDATED_SCHEMA"] = "OUTDATED_SCHEMA";
})(TelemetryType || (exports.TelemetryType = TelemetryType = {}));
//# sourceMappingURL=TelemetryTypeEnum.js.map